<template>
  <div class="main-page col-block" :style="{ minHeight: minHeight }">
    <div class="content-container center-block" :style="{ flex: 1 }">
      <div class="login-container col-block default-shadow">
        <div class="description-container col-block">
          <div class="logo-container row-block">
            <div class="logo-block">
              <img :src="require('../../assets/images/main-logo.png')">
            </div>
            <div class="content-block col-block">
              <div class="title">農業部農業試驗所</div>
              <div
                class="content"
                v-html="[
                  'Taiwan Agricultural Research Institute',
                  'Ministry of Agriculture'
                ].join('<br/>')"
              ></div>
            </div>
          </div>
          <div class="title-container">
            <div class="title">農產業貿易潛力分析平台</div>
            <div
              class="content"
              v-html="[
                '本平台是您進入國際貿易事業決策最佳小幫手，',
                '讓您快速掌握市場趨勢，',
                '從整合數據中綜合分析市場潛力。'
              ].join('<br/>')"
            ></div>
            <div
              class="sub-content"
              v-html="[
                '',
                '建議使用Chrome、Edge、Firefox與1600x900以上之解析度，獲取最佳操作體驗。'
              ].join('<br/>')"
            ></div>
          </div>
        </div>
        <hr />
        <div class="main-container col-block" :style="{ flex: 1 }">
          <div class="title-container row-block">
            <div class="title">會員登入</div>
            <div class="register">
              <router-link class="link" :to="{ name: 'register' }">註冊新帳號</router-link>
            </div>
          </div>
          <div :style="{ flex: 1 }"></div>
          <div class="input-container">
            <div class="row">
              <div class="title input-group col">
                <span>帳號*</span>
              </div>
            </div>
            <div class="row">
              <div class="input-group col">
                <input type="text" id="username" name="username" v-model="user.account" v-validate="'required'" placeholder="帳號" @keydown.enter="e => $refs.password.focus()">
                <p class="error" v-show="errors.has('username')">{{ (errors.first('username') || '').replace('username', '帳號') }}</p>
              </div>
            </div>
            <div class="row">
              <div class="title input-group col">
                <span>密碼*</span>
              </div>
            </div>
            <div class="row">
              <div class="input-group col">
                <input ref="password" type="password" id="password" name="password" v-model="user.password" placeholder="密碼" v-validate="'required'" @keydown.enter="e => validateUserLogin()">
                <p class="error" v-show="errors.has('password')">{{ (errors.first('password') || '').replace('password', '密碼') }}</p>
              </div>
            </div>
            <div class="row">
              <div class="link input-group col">
                <router-link class="link" :to="{ name: 'forgot' }">忘記密碼？</router-link>
              </div>
            </div>
          </div>
          <div :style="{ flex: 3 }"></div>
          <div class="button-container">
            <button type="button" name="button" class="main-button field-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => validateUserLogin()">
              <span>登入</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="footer-container">
    </div> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { postUser } from '../../api'
import loginMethods from '../../mixins/loginData'
import toastMethods from '../../mixins/toastMethods'

export default {
  mixins: [
    loginMethods,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      user: {
        account: '',
        password: ''
      },
      onSubmit: false
    }
  },
  computed: {
    onError () {
      let value = true
      if (this.errors.items.length === 0) {
        value = false
      }
      if (this.loading) {
        value = true
      }
      return value
    }
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setLoadingAction'
    ]),
    async validateUserLogin () {
      this.onSubmit = true
      let result = await this.$validator.validateAll()
      if (result) {
        await this.userLogin()
      } else {
        this.onSubmit = false
      }
    },
    async userLogin () {
      try {
        let data = this.user
        let response = await postUser(data)
        this.$router.push({ name: 'tutorial' })
        this.setUserData(response)
        this.onSubmit = false
      } catch (error) {
        this.setLoginAction(false)
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        this.onSubmit = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/main.vue